type LogDetails = Record<string, string | number | boolean | undefined>;

export function adminLog(event: string, details: LogDetails = {}) {
  console.info('[website-admin]', { event, timestamp: new Date().toISOString(), ...details });
}

export function adminLogError(event: string, error: unknown, details: LogDetails = {}) {
  console.error('[website-admin]', {
    event,
    timestamp: new Date().toISOString(),
    message: error instanceof Error ? error.message : String(error),
    ...details
  });
}
